import { waypointInit } from 'helpers/utils';

const waypointConfig = {
    selector: '.dl',
    funcs: [{ target: 'waypoint--bottom' }],
    offset: '40%',
};

function init() {
    waypointInit(waypointConfig);
}

export default init;



// WEBPACK FOOTER //
// ./app/js/modules/download.js